import { loadStripe } from '@stripe/stripe-js/pure';
import { stringify } from 'qs';
import config from '../../../../app/global/env.config';
import { getAngularServiceOrUndefined } from './get-angular-service';
import { API } from '../../../vendor/api';
let stripeInstance = null;
export const getCurrencies = () => {
    const currencyService = getAngularServiceOrUndefined('currencyService');
    const currencies = currencyService
        ? currencyService.getCurrenciesArray()
        : [];
    return currencies;
};
export const getStripeLink = async (user, institution) => {
    const { stripeClientId, baseUrl } = config;
    const { id, firstName, lastName, email = '' } = user;
    const roomHelpersFactory = getAngularServiceOrUndefined('roomHelpersFactory');
    const firstRoomUrl = roomHelpersFactory
        ? roomHelpersFactory.getRoomBaseUrl()
        : '';
    const OAuthStripeToken = await API.user.generateOAuthStripeToken({ id });
    return `https://connect.stripe.com/oauth/authorize?${stringify({
        response_type: 'code',
        client_id: stripeClientId,
        scope: 'read_write',
        state: `${institution ? institution.domain : ''},${OAuthStripeToken.tokenId}`,
        redirect_uri: `${baseUrl}/oauth/stripe`,
        'stripe_user[email]': email,
        'stripe_user[url]': firstRoomUrl,
        'stripe_user[first_name]': firstName,
        'stripe_user[last_name]': lastName,
        'stripe_user[product_category]': 'professional_services',
        'stripe_user[product_description]': '',
    })}`;
};
export const isOwner = (user, institution) => Boolean(user.institutionsMemberships.find((membership) => membership.institutionId === institution.id && membership.role === 'owner'));
export const connectStripe = async (user, institution) => {
    const stripeLink = await getStripeLink(user, institution);
    window.location.href = stripeLink;
};
export const getStripeInstance = async () => {
    try {
        if (!stripeInstance) {
            stripeInstance = await loadStripe(config.stripePublishable);
        }
        return stripeInstance;
    }
    catch (error) {
        console.error(error);
        return getStripeInstance();
    }
};
